import { Controller } from '@hotwired/stimulus'
import { dispatcher } from './pub_controller'

export class InvoiceTableController extends Controller {
  static values = {
    url: String,
  }

  declare readonly urlValue: string

  dispatchTurboModalGet(event: Event) {
    event.preventDefault()
    const url = (event.currentTarget as HTMLElement).dataset.url
    dispatcher(this, 'turbo-modal-get', 'turbo-modal', url)
  }
}
